// @flow

import React from 'react';
import urlJoin from 'url-join';
import { Redirect, type Match } from 'react-router';

import adminPage from '@app/hocs/admin-page';
import type { PropsMapper } from '@app/hocs/admin-page/admin-page';

import TagDetails from './tag-details';

type Props = {
  match: Match,
};

export const Tag = (props: Props) => (
  <Redirect from={props.match.path} to={urlJoin(props.match.url, '/details')} />
);

export const tagModule: PropsMapper = ({
  props: {
    tag,
    message,
    match,
    fetchTag,
  },
}) => {
  const modules = [
    {
      path: '/details',
      title: message({ id: 'Details', comment: 'The sidebar title' }),
      section: message({
        id: 'Tags',
        comment: 'Used as the title for the section.',
      }),
      component: TagDetails,
    },
  ];

  return ({
    title: tag.name || '',
    showAsLink: false,
    modules: [modules],
    componentDidMount: () => {
      fetchTag(match.params.id);
    },

  });
};

export default adminPage(tagModule)(Tag);
